import PortfolioStatistics from "./PortfolioStatistics";

export default PortfolioStatistics;
